import axios from '../axios/redditlikeApi'

const fetchPosts = (page, size, communities, keyword) => {
  return axios.get('/posts', {
    params: {
      communities,
      keyword,
      page,
      size
    }
  })
}

const getPostById = (id) => axios.get(`/posts/${id}`)

const createPost = form => axios.post('/posts', form)

const deletePost = (id) => axios.delete(`/posts/${id}`)

const updatePost = (id, form) => axios.patch(`/posts/${id}`, form)

export default {
  fetchPosts,
  getPostById,
  createPost,
  deletePost,
  updatePost
}
